<template>
  <div>
    <el-card>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/goodsInfo' }">商品管理</el-breadcrumb-item>
        <el-breadcrumb-item>编辑商品</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>
    <el-card class="box-card" style="margin-top: 20px">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="item.label" :name="item.name" v-for="(item, k) in catogeryList" :key="k">
        </el-tab-pane>
      </el-tabs>
      <div v-if="activeName == 'goodsInfo'">
        <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
          <el-row v-if="addWay != 2">
            <el-col :sm="24" :md="12" :lg="8">
              <el-form-item label="商品类型" prop="type">
                <el-select :disabled="true" v-model="addForm.type" placeholder="请选择商品类型">
                  <el-option v-for="(item, index) in goodsTypeList" :key="index" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="12" :lg="8" v-if="loginData.agentId == 621995219419136">
              <el-form-item label="" prop="mainAppShow">
                <el-checkbox v-model="addForm.mainAppShow" :true-label="1" :false-label="-1">弘智课堂APP显示</el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="addWay != 2">
            <el-col :sm="24" :md="24" :lg="16">
              <el-form-item label="商品名称" prop="name">
                <el-input v-model="addForm.name" placeholder="请输入商品名称" auto-complete="off" maxlength="20"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="addWay != 2">
            <el-col :sm="24" :md="24" :lg="16">
              <el-form-item label="商品封面" prop="img">
                <div class="upload-div">
                  <div class="upload-content">
                    <div></div>
                    <div class="content-texts">
                      <span class="content-texts">至少上传1张，最多上传3张，JPG、PNG格式，每张图片不超过2M,第一张为主图，可拖动图片进行排序，建议尺寸750*560px或4：3</span>
                    </div>
                  </div>
                </div>
                <div class="img-list">
                  <div v-if="addForm.imgs.length">
                    <draggable v-model="addForm.imgs" @update="datadragEnd" :options="{ animation: 500 }">
                      <div class="upload-img" v-for="(item, index) in addForm.imgs" :key="index">
                        <el-image class="upload-img" :src="item" :preview-src-list="addForm.imgs"></el-image>
                        <div @click="deleteImg(index)" class="delete-img">
                          <i class="el-icon-close icons"></i>
                        </div>
                        <div class="main-img">
                          {{ index == 0 ? '主图' : '附图' + index }}
                        </div>
                      </div>
                    </draggable>
                  </div>
                  <div v-if="addForm.imgs.length < 3">
                    <el-upload class="crm-upload" :action="fileObj.url" :on-remove="handleRemove" :on-change="handleChange" :before-upload="beforeUpload" :on-success="UploadSuccess" :headers="reqData" :on-exceed="handleExceed" multiple :limit="3" list-type="picture" :show-file-list="false">
                      <img class="upload-img" :src="defaultImg" alt />
                    </el-upload>
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :sm="24" :md="24" :lg="16">
              <el-form-item label="上传视频" prop="videoUrl" v-loading="loadVideo">
                <div class="editPointC">
                  <el-upload class="avatar-uploader-logo" action :show-file-list="false" ref="upload" :http-request="videoUrlUploadRequest1">
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                    <video class="currencySetting-image" style="margin-left: 20px;float:right;" v-if="addForm.videoUrl" :src="addForm.videoUrl" height="100" width="160"></video>
                  </el-upload>
                  <div class="paySetting-tips">
                    支持mp4、avi、wmv格式，大小不超过2GB
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="addWay != 2">
            <el-col :sm="24" :md="12" :lg="8">
              <el-form-item label="所属科目" prop="subjectId">
                <el-cascader style="width: 100%" clearable :disabled="true" v-model="courseIds" :empty="addForm.subjectCourseName" :show-all-levels="false" :props="subjectTreeProps" placeholder="请输入所属科目" :options="subjectTreeList" @change="subjectSearchChange"></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="12" :lg="8" v-if="this.addForm.type !== '免费课程'">
              <el-form-item label="是否免费" prop="free">
                <el-radio v-model="addForm.free" label="-1" @change="freeChange">付费</el-radio>
                <el-radio v-model="addForm.free" label="1" @change="freeChange">免费</el-radio>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :sm="24" :md="12" :lg="8">
              <el-form-item label="地区">
                <el-cascader style="width: 100%" clearable collapse-tags v-model="dictionaryIds" :show-all-levels="false" :props="dictionaryProps" placeholder="请选择地区" :options="dictionaryIdList"></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :sm="24" :md="12" :lg="8">
              <el-form-item label="分类">
                <el-select multiple v-model="addForm.classificationIdList" placeholder="请选择分类" style="width: 100%" clearable>
                  <el-option v-for="item in classificationIdOptions" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :sm="24" :md="12" :lg="8">
              <el-form-item label="是否限购" prop="flashSaleType">
                <el-radio v-model="addForm.flashSaleType" :label="1">是</el-radio>
                <el-radio v-model="addForm.flashSaleType" :label="-1">否</el-radio>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :sm="24" :md="12" :lg="8">
              <el-form-item label="限时抢购价">
                <el-input type="number" min="0" v-model="addForm.snapPrice" placeholder="请输入限时抢购价(RMB)" auto-complete="off" maxlength="10"></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="12" :lg="8">
              <el-form-item label="限购时间" prop="validDay">
                <el-date-picker style="width: 100%" v-model="purchaseDateRange" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" @change="editGoodsDateRangeChange"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :sm="24" :md="12" :lg="8">
              <el-form-item label="原价" prop="originalPrice">
                <el-input type="number" min="0" v-model="addForm.originalPrice" placeholder="请输入原价(RMB)" auto-complete="off" @change="originalPriceChange" maxlength="10"></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="12" :lg="8">
              <!-- {{addForm.price}} -->
              <el-form-item label="折后价" prop="price">
                <el-input :disabled="!addForm.originalPrice > 0 || addForm.free == '1'" type="number" min="0" v-model="addForm.price" placeholder="请输入折后价" auto-complete="off" maxlength="10">
                  <template slot="append">
                    <el-select style="width: 90px" v-model="discount" @change="discountChange()" :disabled="addForm.free == '1'" :placeholder="placeholderdiscount">
                      <el-option v-for="(item, index) in discountOptions" :key="index" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :sm="24" :md="12" :lg="8">
              <el-form-item label="显示销量" prop="sellCount">
                <el-input type="number" min="0" v-model="addForm.sellCount" placeholder="请输入显示销量" auto-complete="off" maxlength="10"></el-input>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="12" :lg="8" v-if="addWay != 2">
              <el-form-item label="有效天数" prop="validDay">
                <el-input type="number" min="0" v-model="addForm.validDay" placeholder="请输入有效天数" auto-complete="off" :disabled="validDayDisabled" maxlength="10">
                  <template slot="append">
                    <el-checkbox v-model="validDayRadio" label="1" @change="validDayNull()">不限</el-checkbox>
                  </template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="addWay != 2">
            <el-col :sm="24" :md="12" :lg="8">
              <el-form-item label="上架时间" prop="onTime">
                <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOptions2" style="width: 100%" @change="timechange1" v-model="addForm.onTime" type="datetime" placeholder="请选择上架时间"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :sm="24" :md="12" :lg="8">
              <el-form-item label="失效时间" prop="offTime">
                <el-date-picker v-model="addForm.offTime" :disabled="offTimeDisabled" style="width: calc(100% - 60px)" value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOptions2" @change="timechange2" type="datetime" placeholder="请选择失效时间"></el-date-picker>
                <el-checkbox v-model="offTimeRadio" label="1" @change="offTimeNull()">不限</el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-if="addWay !== 2">
            <el-col :sm="24" :md="12" :lg="8">
              <el-form-item label="提问次数" prop="questionTimes">
                <el-input-number v-model="addForm.questionTimes" :min="1" label="提问次数"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-if="addWay != 2">
            <el-col :sm="24" :md="24" :lg="16">
              <el-form-item label="课程简介">
                <el-input v-model="addForm.summary" placeholder="请输入课程简介" auto-complete="off" maxlength="1000"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="addWay != 2">
            <el-col :sm="24" :md="24" :lg="16">
              <el-form-item label="商品介绍" prop="detail">
                <!-- <el-input
              type="textarea"
              v-model="addForm.detailueTtext"
              placeholder="请输入详细介绍"
              auto-complete="off"
              maxlength="65535"
              ></el-input>-->
                <div style="background: #fff" v-if="showUe">
                  <UE name="1" :value="ueTtext" ref="myQuillEditorTitle"></UE>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div>
          <el-button @click="addFormBack">重置</el-button>
          <el-button type="primary" @click="addGoodsInfo">提交</el-button>
        </div>
      </div>
      <div v-if="activeName == 'service'" class="">
        <Service/>
      </div>
      <div v-if="activeName == 'comment'" class="commentBox">
        <!-- <div class="blockItem" style="border-right:1px solid rgb(225, 235, 250);">
          <div class="cTtitle">虚拟评价</div>
          <div class="trightT">头像姓名随机生成</div>
          <div class="simulaComment" v-for="(item, udx) in commentList" :key="udx">
            <el-input v-model="item.comment" placeholder="请输入" auto-complete="off" maxlength="250" style="width:80%;"></el-input>
            <el-button type="primary" @click="addFake(udx)" icon="el-icon-circle-plus" style="margin-left:10px" v-if="udx == 0">添加</el-button>
            <el-button type="primary" @click="minusFake(udx)" icon="el-icon-remove-outline" style="margin-left:10px" v-else>移除</el-button>
          </div>
        </div> -->
        <div class="blockItem">
          <div class="cTtitle">真实评价</div>
          <div class="trightT">共{{ commentList.length }}条</div>
          <div class="realComment" v-for="(item, idx) in commentList" :key="idx">
            <img :src="item.student.studentHeadPic ? item.student.studentHeadPic : defaultHead" class="headImg" alt="">
            <div class="stuDetail">
              <div class="sTop">
                <div class="name">{{ item.student.name }}</div>
                <div class="time">{{ item.createTime }}</div>
                <el-switch @change="commentStateChange(item)" v-model="item.state" :active-value="1" :inactive-value="-1" class="switchStyle2" active-text="开" inactive-text="关"></el-switch>
              </div>
              <div class="sBot">{{ item.content }}</div>
            </div>
          </div>
          <div class="tct" v-if="commentList.length <= 0">暂无数据</div>
        </div>
      </div>
      <!-- <div class="btnCenter" v-if="activeName == 'comment'">
        <el-button type="primary" @click="addConfirm">保存</el-button>
      </div> -->
    </el-card>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { uploadOSS } from "../../upload/upload";
import UE from "../conmom/CKEditorInformation.vue";
import draggable from "vuedraggable";
import Service from "./components/Service";
export default {
  components: { UE, draggable, Service },
  data () {
    return {
      defaultHead: 'http://68wx--test.oss-cn-hangzhou.aliyuncs.com/image/teacherHead.jpg',
      commentList: [{ comment: '' }, { comment: '' }, { comment: '' },],
      activeName: 'goodsInfo',
      catogeryList: [
        {
          label: '商品信息',
          name: 'goodsInfo'
        }, {
          label: '赠品和服务',
          name: 'service'
        }, {
          label: '商品评价',
          name: 'comment'
        }
      ],
      classificationIdOptions: [],
      addWay: 1,
      postDisabled: false,
      showUe: true,
      validDayRadio: null,
      checked: false,

      offTimeDisabled: false,
      validDayDisabled: false,
      placeholderdiscount: "不打折",
      purchaseDateRange: '',
      defaultImg: "../../../static/image/defaultImg2.png",
      fileObj: {
        url: process.env.BASE_URL + "/system/uploadFile",
      },
      ueTtext: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      pickerOptions2: {
        disabledDate (time) {
          return time.getTime() < new Date(new Date().toLocaleDateString()).getTime();
        },
      },
      subjectTreeList: [], //科目
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      dictionaryIdList: [], // 分类
      dictionaryProps: {
        value: "id",
        label: "name",
        children: "dictionaries",
        multiple: true,
      },
      addTeacherList: [],
      dictionaryIds: [], //分类id
      offTimeRadio: null,
      validDayRadio: null,
      material: 0,
      addForm: {
        name: "",
        imgs: [],
        img: "",
        flashSaleType: 1,
        stopTime: '',
        startTime: '',
        free: "-1",
        subjectId: "",
        originalPrice: "",
        price: "",
        validDay: "365",
        material: "",
        sell: "1",
        stock: "",
        sellCount: "",
        onTime: "",
        offTime: "",
        questionTimes: 1000,
        summary: "",
        detail: "",
      },
      formLabelWidth: "80px",
      addFormRules: {
        name: [
          {
            required: true,
            message: "请输入商品名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 20,
            message: "商品名称长度在1到100个字",
          },
        ],
        validDay: [
          {
            required: true,
            message: "请输入有效天数",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "有效天数格式不正确",
          },
        ],
        img: {
          required: true,
          message: "请选择商品图片",
          trigger: "change",
        },
        free: {
          required: true,
          message: "请选择付费",
          trigger: "change",
        },
        onTime: {
          required: true,
          message: "请选择上架时间",
          trigger: "change",
        },
        // img: [
        //   {
        //     required: true,
        //     message: "请输入图标",
        //     trigger: "blur"
        //   },
        //   {
        //     min: 1,
        //     max: 300,
        //     message: "图标长度在1到300个字"
        //   }
        // ],

        validDay: [
          {
            required: true,
            message: "请输入有效天数",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "有效天数格式不正确",
          },
        ],
        tags: [
          {
            required: true,
            message: "请输入标签",
            trigger: "blur",
          },
          {
            min: 1,
            max: 1000,
            message: "标签长度在1到1000个字",
          },
        ],
        subjectId: [
          {
            required: true,
            message: "请选择所属科目",
            trigger: "change",
          },
        ],
        postpone: [
          {
            required: true,
            message: "请输入是否支持延期",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "是否支持延期格式不正确",
          },
        ],
        sellCount: [
          {
            required: true,
            message: "请输入显示销量",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "显示销量格式不正确",
          },
        ],
        price: [
          {
            required: true,
            message: "请输入折后价",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "折后价格式不正确",
          },
        ],
        originalPrice: [
          {
            required: true,
            message: "请输入原价",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "原价格式不正确",
          },
        ],
        summary: [
          {
            required: true,
            message: "请输入摘要",
            trigger: "blur",
          },
          {
            min: 1,
            max: 1000,
            message: "摘要长度在1到1000个字",
          },
        ],
        detail: [
          {
            required: true,
            message: "请输入详细介绍",
            trigger: "blur",
          },
          {
            min: 1,
            max: 65535,
            message: "详细介绍长度在1到65535个字",
          },
        ],
      },
      discountOptions: [
        {
          value: "1",
          label: "不打折",
        },
        {
          value: "0.9",
          label: "9折",
        },
        {
          value: "0.8",
          label: "8折",
        },

        {
          value: "0.7",
          label: "7折",
        },
        {
          value: "0.6",
          label: "6折",
        },
        {
          value: "0.5",
          label: "5折",
        },
        {
          value: "0.4",
          label: "4折",
        },
        {
          value: "0.3",
          label: "3折",
        },
        {
          value: "0.2",
          label: "2折",
        },
        {
          value: "0.1",
          label: "1折",
        },
      ],
      subjectTreeList: [], //科目
      goodsTypeList: [], //type
      courseIds: [], //科目
      validDayDisabled: false,
      discount: "",
      loadVideo: false,
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
      },
    };
  },
  watch: {
    "addForm.price": function (newVal) {
      // if (Number(this.addForm.originalPrice) > 0) {
      //   this.placeholderdiscount =
      //     (
      //       Number(this.addForm.price) / Number(this.addForm.originalPrice)
      //     ).toFixed(2) *
      //       10 ==
      //     10
      //       ? "不打折"
      //       : (
      //           Number(this.addForm.price) / Number(this.addForm.originalPrice)
      //         ).toFixed(2) *
      //           10 +
      //         "折";
      //   if (Number(this.addForm.price) > Number(this.addForm.originalPrice)) {
      //     this.$message.error("输入错误，折后价不能大于原价！！！");
      //     // this.addForm.price = "";
      //   }
      // }
    },
    // "addForm.originalPrice": function(newVal) {
    //   this.addForm.price = this.addForm.originalPrice;
    // }
  },
  methods: {
    commentStateChange (obj) {
      this.api.goodsInfo.updateGoodsComment({ "id": obj.id, "state": obj.state }).then(res => {
        this.getRealComment()
      })
    },
    addConfirm () { },
    handleClick (va) {
      console.log(va)
      if (va.label == "商品评价") {
        this.getRealComment()
      }
    },
    getRealComment () {
      this.api.goodsInfo.getGoodsCommentList({ goodsId: this.$route.query.updatePageId }).then((result) => {
        if (result.success) {
          console.log(result)
          this.commentList = result.data;
        } else {
          this.$message.error(result.message);
        }
      })
    },
    // 获取分类
    getClassificationIdOptions () {
      this.api.dictionary
        .getDictionaryTreeByParentId({ parentId: "3" })
        .then((res) => {
          this.classificationIdOptions = res.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getTreeData (data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].dictionaries.length === 0) {
          data[i].dictionaries = undefined;
        } else {
          this.getTreeData(data[i].dictionaries);
        }
      }
      return data;
    },
    getGoodsTypeList () {
      this.api.goodsInfo
        .getGoodsTypeList({})
        .then((result) => {
          if (result.success) {
            this.goodsTypeList = result.data;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    validDayNull () {
      if (this.validDayRadio == 1) {
        this.validDayDisabled = true;
        this.addForm.validDay = null;
        this.addFormRules.validDay = [
          {
            required: false,
            message: "请输入有效天数",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "有效天数格式不正确",
          },
        ];
      } else {
        this.validDayDisabled = false;
        this.addFormRules.validDay = [
          {
            required: true,
            message: "请输入有效天数",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "有效天数格式不正确",
          },
        ];
      }
    },
    editGoodsDateRangeChange () {
      if (this.purchaseDateRange) {
        this.addForm.startTime = this.purchaseDateRange[0];
        this.addForm.stopTime = this.purchaseDateRange[1];
      } else {
        this.addForm.startTime = "";
        this.addForm.stopTime = "";
      }
    },
    originalPriceChange () {
      if (this.addForm.free == "1") {
      } else {
        this.addForm.price = this.addForm.originalPrice;
        this.discountChange();
      }
    },
    timechange1 () {
      if (this.addForm.offTime && this.addForm.onTime) {
        if (
          new Date(this.addForm.onTime).getTime() >=
          new Date(this.addForm.offTime).getTime()
        ) {
          return (
            (this.addForm.onTime = ""),
            this.$message.error("上架时间不能大于等于失效时间！！！")
          );
        }
      }
    },
    freeChange (val) {
      if (val == "1") {
        // this.addForm.originalPrice = 0;
        this.addForm.price = 0;
      }
    },
    timechange2 () {
      if (this.addForm.offTime && this.addForm.onTime) {
        if (
          new Date(this.addForm.onTime).getTime() >=
          new Date(this.addForm.offTime).getTime()
        ) {
          return (
            (this.addForm.offTime = ""),
            this.$message.error("上架时间不能大于等于失效时间！！！")
          );
        }
      }
    },
    offTimeNull () {
      if (this.offTimeRadio == 1) {
        this.offTimeDisabled = true;
        this.addForm.offTime = null;
      } else {
        this.offTimeDisabled = false;
      }
    },
    validDayNull () {
      if (this.validDayRadio == 1) {
        this.validDayDisabled = true;
        this.addForm.validDay = null;
        this.addFormRules.validDay = [
          {
            required: false,
            message: "请输入有效天数",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "有效天数格式不正确",
          },
        ];
      } else {
        this.validDayDisabled = false;
        this.addFormRules.validDay = [
          {
            required: true,
            message: "请输入有效天数",
            trigger: "blur",
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "有效天数格式不正确",
          },
        ];
      }
    },
    discountChange () {
      this.checked = false;
      this.addForm.price = parseInt(
        (this.discount ? this.discount : 1) * this.addForm.originalPrice
      );
    },
    checkboxChange (val) {
      if (val) {
        this.addForm.price = this.addForm.originalPrice;
      }
    },
    subjectSearchChange () {
      console.log(this.courseIds);
      if (this.courseIds) {
        this.addForm.subjectId = this.courseIds[1];
      } else {
        this.searchForm.subjectId = "";
      }
    },
    // 分类
    dictionaryIdsChange () {
      if (this.dictionaryIds) {
        this.addForm.dictionaryIdList = [];
        this.dictionaryIds.forEach((e) => {
          let len = e.length;
          this.addForm.dictionaryIdList.push(e[len - 1]);
        });
      } else {
        this.addForm.dictionaryIdList = [];
      }
    },
    deleteImg (index) {
      this.addForm.imgs.splice(index, 1);
      this.$set(this.addForm, "imgs", this.addForm.imgs);
      console.log(this.addForm.imgs);
      this.$forceUpdate();
    },
    datadragEnd (evt) {
      this.$forceUpdate();
      evt.preventDefault();
    },
    getSubjectTreeList () {
      // 获取课程
      this.api
        .getSubjectTreeList()
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                delete items.children;
                // if (items.children.length != 0) {
                //   for (let itemss of items.children) {
                //     delete itemss.children;
                //   }
                // } else {
                //   // delete items.children;
                // }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
          this.getGoodsInfo();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    UploadSuccess (res, file, fileList, val) {
      this.addForm.imgs.push(res.data);
      this.$set(this.addForm, "imgs", this.addForm.imgs);

      this.$forceUpdate();
    },
    handleExceed (files, fileList) {
      this.$message.warning(
        `商品图片最多可选择3张，本次选择了 ${files.length} 个图片，共选择了 ${files.length + fileList.length
        } 个图片`
      );
    },
    handleRemove (file, fileList) { },
    handleChange (file, fileList) { },
    beforeUpload (file) {
      if (this.addForm.imgs.length == 3) {
        return this.$message.error("商品图片最多上传三张");
      }
      const isJPG = file.type.indexOf("image") > -1;
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传文件必须是图片哦!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    addFormBack () {
      this.addForm.name = "";
      this.addForm.img = "";
      this.addForm.sell = 1;
      this.addForm.imgs = [];

      this.addForm.subjectId = "";
      this.addForm.originalPrice = "";
      this.addForm.price = "";
      this.addForm.validDay = "365";
      this.addForm.material = "";
      this.addForm.stock = "";
      this.addForm.sellCount = "";
      this.addForm.onTime = "";
      this.addForm.offTime = "";
      this.addForm.summary = "";
      this.addForm.detail = "";
      //this.$router.push({ path: "/goodsInfo" });
    },
    addGoodsInfo () {
      if (this.$refs.myQuillEditorTitle._data.content) {
        this.addForm.detail = this.$refs.myQuillEditorTitle._data.content;
        this.addForm.img = this.addForm.imgs.toString();
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            if (Number(this.addForm.price) > Number(this.addForm.originalPrice)) {
              return this.$message.error("输入错误，折后价不能大于原价！！！");
              // this.addForm.price = "";
            }
            if (this.addForm.onTime && this.addForm.offTime)
              if (
                new Date(this.addForm.onTime).getTime() >=
                new Date(this.addForm.offTime).getTime()
              ) {
                return this.$message.error("上架时间不能大于等于失效时间！！！");
              }
            if (this.addForm.imgs.length > 0) {
              this.addForm.logo = this.addForm.imgs[0];
            }
            this.api.goodsInfo
              .updateGoodsInfo(this.addForm)
              .then((result) => {
                if (result.success) {
                  this.$message({
                    type: "success",
                    message: result.message,
                  });
                  // this.$router.push(
                  //   {
                  //     path: "/goodsInfo/goodsItem",
                  //     query: {updatePageGoodsItem: this.$route.query.updatePageId
                  //   }},
                  // );
                  this.$router.push({ path: "/goodsInfo" });
                } else {
                  this.$message.error(result.message);
                }
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            return false;
          }
        });
      } else {
        this.$message.error("商品介绍不能为空");
      }
    },
    getGoodsInfo () {
      this.showUe = false;
      this.api.goodsInfo
        .getGoodsInfo({
          id: this.$route.query.updatePageId,
        })
        .then((result) => {
          result.data.free = result.data.free.toString();
          this.addForm = result.data;
          this.purchaseDateRange = result.data.startTime
            ? [result.data.startTime, result.data.stopTime]
            : "";
          if (result.data.material) {
            this.material = "1";
          } else {
            this.material = "0";
          }
          if (result.data.onTime == null) {
            result.data.onTime = result.data.createTime;
          }
          if (result.data.dictionaryIdList) {
            let arr = [];
            result.data.dictionaryIdList.forEach((item) => {
              arr.push(getFathersById(item, this.dictionaryIdList));
            });
            this.dictionaryIds = arr;
          }
          if (result.data.img) {
            this.addForm.imgs = result.data.img.split(",");
          } else {
            this.addForm.imgs = [];
          }
          // this.courseIds = ["1197773608737206274", "1198096732914819074"];
          if (this.addForm.offTime == null) {
            this.offTimeRadio = true;
            this.offTimeDisabled = true;
          } else {
            this.offTimeRadio = null;
            this.offTimeDisabled = false;
          }
          if (this.addForm.validDay == null) {
            this.validDayRadio = true;
            this.validDayDisabled = true;
            this.addFormRules.validDay = [
              {
                required: false,
                message: "请输入有效天数",
                trigger: "blur",
              },
              {
                pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
                message: "有效天数格式不正确",
              },
            ];
          } else {
            this.validDayRadio = null;
            this.validDayDisabled = false;
            this.addFormRules.validDay = [
              {
                required: true,
                message: "请输入有效天数",
                trigger: "blur",
              },
              {
                pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
                message: "有效天数格式不正确",
              },
            ];
          }
          this.subjectTreeList.forEach((element) => {
            if (element.children) {
              element.children.forEach((elements) => {
                console.log(123, this.addForm.subjectId);
                if (elements.id == this.addForm.subjectId) {
                  this.courseIds = [element.id, elements.id];
                  // this.courseIds.push(element.id);
                  // this.courseIds.push(elements.id);
                }
              });
            }
          });
          this.ueTtext = this.addForm.detail;
          this.addForm.sell = String(this.addForm.sell);
          this.showUe = true;
          this.placeholderdiscount =
            (this.addForm.price / this.addForm.originalPrice).toFixed(2) * 10 + "折";
        })
        .catch((error) => {
          console.log(error);
        });
    },
    videoUrlUploadRequest1 (file) {
      this.loadVideo = true
      console.log("file", file);
      const isJPG = file.file.type === "video/mp4" || file.file.type === "video/avi" || file.file.type === "video/wmv";
      if (!isJPG) {
        this.$message.error("上传视频只支持mp4、avi、wmv格式!");
        return;
      }
      if (file.file.size / 1024 / 1024 > 2000) {
        this.$message.error("视频大小不能超过2G");
        return;
      } else {
        uploadOSS(file, "generalSetting").then((result) => {
          this.$set(this.addForm, "videoUrl", result);
          this.loadVideo = false
        });
      }
    },
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData () {
      return this.$store.state.user;
    },
    dictionaryIdList () {
      if (this.$store.state.dictionaryIdList == undefined) {
        this.$store.dispatch("getDictionaryIdList");
      } else {
        return this.$store.state.dictionaryIdList;
      }
    },
  },
  mounted () {
    if (this.$store.state.dictionaryIdList == undefined) {
      this.$store.dispatch("returnDictionaryIdList").then((res) => {
        this.dictionaryIdList = res;
        this.getSubjectTreeList();
      });
    } else {
      this.dictionaryIdList = this.$store.state.dictionaryIdList;
      this.getSubjectTreeList();
    }
    this.addWay = 1;
    this.getSubjectTreeList();
    this.getGoodsTypeList();
    this.getClassificationIdOptions();
  },
};
</script>
<style lang="less" scoped>
.list-name-img {
  display: flex;
  flex-direction: row;
  align-items: center;

  img {
    width: 40px;
    height: 40px;
    border-radius: 4px;
    margin-right: 10px;
  }
}

.img-list {
  display: flex;
  margin-top: 10px;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;

  .select {
    opacity: 0.6;
    background: #333;
  }

  .main-img {
    margin: 0 10px;
    text-align: center;
    font-size: 14px;
    margin-top: -20px;
    width: 160px;
    height: 40px;
    line-height: 40px;
  }

  .upload-img {
    display: inline-block;
    width: 160px;
    height: 100px;
    border-radius: 4px;
    margin: 0 10px;
    position: relative;
    cursor: pointer;
    padding: 0px;
  }

  .delete-img {
    top: -5px;
    right: -10px;
    // width: 160px;
    // height: 100px;
    border-radius: 4px;
    position: absolute;
    z-index: 12;
    cursor: pointer;

    .icons {
      color: #fff;
      background-color: #333;
      border-radius: 50%;
      font-weight: bolder;
      z-index: 1343;
      font-size: 20px;
    }
  }
}

.upload-div {
  display: flex;
  flex-direction: row;

  .upload-content {
    // margin-left: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .content-text {
      width: 80px;
      height: 32px;
      border-radius: 4px;
      border: 1px solid rgb(77, 148, 255);
      color: rgb(77, 148, 255);
      font-size: 12px;
      line-height: 32px;
    }

    .content-texts {
      color: rgb(162, 170, 188);
      font-size: 12px;
      white-space: nowrap;
      // margin-left: 5px;
    }
  }
}

.el-radio+.el-radio {
  margin-left: 0px !important;
}

.margin-left {
  margin: 0px !important;
}

.avatar-uploader-logo {
  margin-top: 20px;
}

.avatar-uploader-logo .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-logo .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 57px;
  color: #0C0C0C;
  width: 160px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  background-color: #F7F7F7;
  margin: 0 10px;
}

.avatar {
  width: 60px;
  height: 60px;
  display: block;
}

.editPointC .el-upload--text {
  display: flex;
}


// 评价---------------------------------------------------------------------------------------------------------
.commentBox {
  display: flex;
  width: 100%;

  .blockItem {
    width: 50%;
    padding: 30px;
    box-sizing: border-box;

    .trightT {
      text-align: right;
      margin: 20px 0;
    }

    .cTtitle {
      background: rgb(225, 235, 250);
      width: 300px;
      height: 40px;
      margin: 0 auto;
      font-size: 14px;
      line-height: 40px;
      text-align: center;
    }
  }
}

.simulaComment {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.btnCenter {
  display: flex;
  margin: 20px 0;
  justify-content: center;
}

.realComment {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 30px;

  .headImg {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    margin-right: 20px;
    align-items: center;
  }

  .stuDetail {
    width: 399px;
  }

  .sBot {
    margin-top: 15px;
  }

  .time {
    margin-left: auto;
    margin-right: 10px;
  }

  .sTop {
    display: flex;
  }
}

.tct {
  text-align: center;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/goods/editGoodsTaocan.vue